export function hasOptionLabelMatch(
  value: unknown,
  options?: readonly { label: string; value: unknown }[],
): boolean {
  if (!options?.length || value == null || value === '') return false;
  return options.some((option) => String(option.value) === String(value));
}

/** Hold label-value display until async select options resolve — avoids flashing raw IDs. */
export function shouldDeferAsyncOptionLabel(
  needsAsyncOptionResolve: boolean,
  isAsyncOptionsLoading: boolean,
  value: unknown,
  options?: readonly { label: string; value: unknown }[],
): boolean {
  if (!needsAsyncOptionResolve || !isAsyncOptionsLoading) return false;
  if (value == null || value === '') return false;
  return !hasOptionLabelMatch(value, options);
}
